import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Cart/ShoppingCartOverview/shoppingCartOverview.container"
    ).then((module) => ({
        default: module.ShoppingCartOverviewContainer
    }))
);
